import { anonymousClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'

const fetchFieldsOfStudy = async () => {
    return anonymousClient()
        .get(
            `/api/fields-of-study`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not retrieve fields of study`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchFieldsOfStudy,
}